import autosize from 'autosize';
export function autoresize(node) {
    autosize(node);
}
